import { render, staticRenderFns } from "./quoted.vue?vue&type=template&id=19bc57fc&scoped=true&"
import script from "./quoted.vue?vue&type=script&lang=js&"
export * from "./quoted.vue?vue&type=script&lang=js&"
import style0 from "./quoted.vue?vue&type=style&index=0&id=19bc57fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19bc57fc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/h5-web-gold/h5-web-gold/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19bc57fc')) {
      api.createRecord('19bc57fc', component.options)
    } else {
      api.reload('19bc57fc', component.options)
    }
    module.hot.accept("./quoted.vue?vue&type=template&id=19bc57fc&scoped=true&", function () {
      api.rerender('19bc57fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/quoted.vue"
export default component.exports